<script setup lang="ts">
import { computed } from 'vue';

import type { IconProps } from 'lib/components/icon/Icon.vue.d';

const props = withDefaults(defineProps<IconProps>(), {
  severity: undefined,
  info: undefined,
  tooltipPos: 'bottom',
  class: undefined,
});

const severityClass = ((): string => {
  switch (props.severity) {
    case 'primary':
      return 'text-primary-500 dark:text-primary-300';
    case 'success':
      return 'text-success-500 dark:text-success-300';
    case 'warning':
      return 'text-warning-500 dark:text-warning-300';
    case 'danger':
      return 'text-danger-500 dark:text-danger-300';
    case 'info':
      return 'text-info-500 dark:text-info-300';
    default:
      return 'inherit dark:inherit';
  }
})();

const classes = computed(() => [
  'icon',
  `ic-${props.icon}`,
  severityClass,
  'cursor-pointer !shrink-0',
]);
</script>

<template>
  <i
    v-if="tooltipPos === 'top'"
    v-tooltip.top="info"
    v-bind="$attrs"
    :class="[...classes, $props['class']]"
  />

  <i
    v-if="tooltipPos === 'bottom'"
    v-tooltip.bottom="info"
    v-bind="$attrs"
    :class="[...classes, $props['class']]"
  />

  <i
    v-if="tooltipPos === 'right'"
    v-tooltip.right="info"
    v-bind="$attrs"
    :class="[...classes, $props['class']]"
  />

  <i
    v-if="tooltipPos === 'left'"
    v-tooltip.left="info"
    v-bind="$attrs"
    :class="[...classes, $props['class']]"
  />
</template>
